var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "choice-user-detail-item"
  }, [_vm.clientInfo.id ? _c('div', {
    staticClass: "div-block-102 applicant-card"
  }, [_c('div', {
    staticClass: "div-block-104 applicant-heading"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-103 aside"
  }, [_c('div', {
    staticClass: "applicant-role"
  }, [_vm._v(_vm._s(_vm.clientInfo.type))]), _vm.clientInfo.id ? _c('div', {
    staticClass: "bold pointer"
  }, [_c('user-manager-handler', {
    attrs: {
      "class-cst": 'blc-color',
      "client-info": _vm.client,
      "rules": ['priority'],
      "dti": "",
      "client": "",
      "detail": ""
    }
  })], 1) : _vm._e()])]), _vm.incomeRecalculating ? _c('div', {
    staticClass: "income-recalculation-status",
    attrs: {
      "role": "status"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 18,
      "width": 2
    }
  }), _vm._v(" Prepočítavam príjem a výšku hypotéky… ")], 1) : _vm._e(), _vm.compact ? _c('div', {
    staticClass: "applicant-summary",
    attrs: {
      "aria-busy": String(_vm.incomeRecalculating)
    }
  }, [_c('div', {
    staticClass: "applicant-metric"
  }, [_c('div', {
    staticClass: "applicant-metric-label",
    attrs: {
      "title": "Najvyšší mesačný príjem, ktorý niektorá z bánk akceptuje z evidovaných príjmov."
    }
  }, [_vm._v(" Akceptovaný príjem ")]), _vm.incomeRecalculating ? _c('div', {
    staticClass: "applicant-metric-value"
  }, [_vm._v("Prepočítavam…")]) : _c('div', {
    staticClass: "applicant-metric-value positive"
  }, [_vm._v("+" + _vm._s(_vm._f("dotTheAmount")(_vm.totalAcceptedMonthlyIncome)) + " EUR/mes.")]), _c('div', {
    staticClass: "applicant-metric-note"
  }, [_vm._v(_vm._s(_vm.activeIncomesLabel) + " · najlepšia banka")])]), _c('div', {
    staticClass: "applicant-metric"
  }, [_c('div', {
    staticClass: "applicant-metric-label",
    attrs: {
      "title": "Mesačné splátky aktívnych záväzkov používané pri výpočte DSTI."
    }
  }, [_vm._v(" Splátky záväzkov ")]), _c('div', {
    staticClass: "applicant-metric-value"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.totalMonthlyDebtPayments)) + " EUR/mes.")]), _c('div', {
    staticClass: "applicant-metric-note"
  }, [_vm._v(_vm._s(_vm.activeDebtsLabel))])]), _c('div', {
    staticClass: "applicant-metric applicant-metric-total"
  }, [_c('div', {
    staticClass: "applicant-metric-label",
    attrs: {
      "title": "Orientačný maximálny úver podľa DTI. Nejde o mesačný príjem ani DSTI."
    }
  }, [_vm._v(" Orientačný DTI limit ")]), _vm.incomeRecalculating ? _c('div', {
    staticClass: "applicant-metric-value"
  }, [_vm._v("Prepočítavam…")]) : _c('div', {
    staticClass: "applicant-metric-value"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.totalDtiLimit)) + " EUR")]), _c('div', {
    staticClass: "applicant-metric-note applicant-metric-note--important"
  }, [_vm._v("max. úver · nie mesačný príjem")])])]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.compact,
      expression: "!compact"
    }],
    staticClass: "applicant-detail-content"
  }, [_c('div', {
    staticClass: "DTIitems"
  }, [_vm._l(_vm.incomesGetter, function (income) {
    var _income$dti;
    return income.is_active ? _c('div', {
      key: income.id,
      staticClass: "input-block contrast p-relative",
      attrs: {
        "id": "income-dti"
      }
    }, [_c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.deactivateIncome(income.id);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]), _c('div', {
      staticClass: "closebtn-broker-app pointer edit",
      on: {
        "click": function click($event) {
          return _vm.finishIncome(income);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"
      }
    })]), _c('div', {
      staticClass: "div-block-101"
    }, [_c('div', [income.zamestnavatel ? _c('span', [_vm._v(" " + _vm._s(income.zamestnavatel.name) + " (" + _vm._s(_vm.translateIncomeType(income.druh)) + ") ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.translateIncomeType(income.druh)) + " ")])]), income.loading ? _c('v-progress-circular', {
      staticClass: "loading-spinner extrasmall",
      attrs: {
        "indeterminate": ""
      }
    }) : _c('div', {
      staticClass: "income-dti-breakdown"
    }, [_c('div', {
      staticClass: "bold positive"
    }, [_vm._v("+" + _vm._s(_vm._f("dotTheAmount")(_vm.acceptedMonthlyIncome(income))) + " EUR/mes.")]), _c('div', {
      staticClass: "applicant-metric-note"
    }, [_vm._v("DTI limit " + _vm._s(_vm._f("dotTheAmount")((_income$dti = income.dti) === null || _income$dti === void 0 ? void 0 : _income$dti.value)) + " EUR")])])], 1), income.error ? _c('div', {
      staticClass: "div-block-112"
    }, [_c('div', {
      staticClass: "text-cta pointer",
      on: {
        "click": function click($event) {
          return _vm.finishIncome(income);
        }
      }
    }, [_vm._v(" DOKONČIŤ ")])]) : _vm._e()]) : _vm._e();
  }), _vm._l(_vm.debtsGetter, function (debt, index) {
    var _debt$dti, _debt$zostatok;
    return debt.mortgage_plan !== 'refinance' ? _c('div', {
      key: debt.id,
      staticClass: "input-block contrast p-relative"
    }, [_c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.deactivateDebt(debt.id);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]), _c('div', {
      staticClass: "closebtn-broker-app pointer edit",
      on: {
        "click": function click($event) {
          return _vm.finishDebt(debt);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"
      }
    })]), _c('div', {
      staticClass: "div-block-101",
      attrs: {
        "id": "debt-dti"
      }
    }, [_c('div', [_vm._v(" " + _vm._s(_vm.translateDebtType(debt.typ)) + " "), _c('strong', [_vm._v(_vm._s(_vm.translateBank(debt.banka)))]), _vm._v(" " + _vm._s(debt.cislo_uveru ? "č." + debt.cislo_uveru : "") + " ")]), debt.loading ? _c('v-progress-circular', {
      staticClass: "loading-spinner extrasmall",
      attrs: {
        "indeterminate": ""
      }
    }) : _c('div', {
      staticClass: "bold"
    }, [debt.dti ? _c('div', [_vm._v(_vm._s(_vm._f("dotTheAmount")((_debt$dti = debt.dti) === null || _debt$dti === void 0 ? void 0 : _debt$dti.value)) + " EUR")]) : _c('div', [_vm._v(_vm._s(_vm._f("dotTheAmount")((_debt$zostatok = debt.zostatok) === null || _debt$zostatok === void 0 ? void 0 : _debt$zostatok.value)) + " EUR")])]), debt.error ? _c('div', {
      staticClass: "text-cta pointer"
    }, [_vm._v(" DOPLNIŤ ")]) : _vm._e()], 1), _c('div', {
      staticClass: "debt-activation-picker"
    }, [_c('dropdown-select', {
      attrs: {
        "first-time-prop": true,
        "id": 'activation-picker' + debt.id,
        "init-value": debt.mortgage_plan === 'keep',
        "options": _vm.activationPicker,
        "custom-css": 'debt-activation-picker',
        "value-correction": _vm.debtDtiActivationCorrection[index],
        "dual-input": "",
        "normal": ""
      },
      on: {
        "select-to-from": function selectToFrom($event) {
          return _vm.changeActivationOfDebt($event, debt, index);
        },
        "value-corrected": function valueCorrected($event) {
          return _vm.debtDtiActivationCorrection.splice(index, 1, null);
        }
      }
    })], 1)]) : _vm._e();
  })], 2), _vm.debtsGetter.filter(function (d) {
    return d.is_visible;
  }).length + _vm.incomesGetter.filter(function (d) {
    return d.is_active;
  }).length > 1 ? _c('div', {
    staticClass: "DTIsummary"
  }, [_vm._v(" celkom "), _c('span', {
    staticClass: "black"
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.totalDti)) + " EUR ")])]) : _vm._e()]), _c('div', {
    staticClass: "client-actions"
  }, [_c('client-personal-info-handler', {
    attrs: {
      "client-info": _vm.personalInfo,
      "client-profile": _vm.client.client_profile,
      "rules": ['priority'],
      "action-button": _vm.compact,
      "action-label": _vm.compact ? 'Bonita' : '',
      "mortgage-context": ""
    }
  }), _c('client-income-handler', {
    attrs: {
      "rules": ['priority'],
      "client-info": _vm.clientInfo,
      "action-button": _vm.compact,
      "action-label": _vm.compact ? 'Príjmy' : ''
    }
  }), _c('client-debt-handler', {
    attrs: {
      "type": 'classic',
      "rules": ['priority'],
      "title": _vm.compact ? 'Výdavky' : 'upraviť VÝDAVKY',
      "client-info": _vm.clientInfo,
      "action-button": _vm.compact
    }
  }), _vm.clientInfo.type === 'Spolužiadateľ' ? _c('div', {
    staticClass: "div-block-25 remove-coapplicant-action client-action-handler"
  }, [_c('div', {
    staticClass: "add-prijem-btn client-action-button client-action-button--danger",
    on: {
      "click": function click($event) {
        return _vm.removeCoApplicant();
      }
    }
  }, [_c('div', {
    staticClass: "text-small pointer client-action-label"
  }, [_vm._v(" Odobrať ")])])]) : _vm._e()], 1)]) : _c('div', {
    staticClass: "coapplicant-empty-state"
  }, [_c('client-add-handler', {
    attrs: {
      "rules": ['priority'],
      "client-info": _vm.clientInfo
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }